import PersonalTextualInfoDefaultProps from "segments/desktop/core-components/person-textual-info/default-props";

export default {
  theme: "iris",
  quote: "“Huge Collaborative Projects, or Daily Personal To-Do's: monday.com Can Change Your Life!“",
  ...PersonalTextualInfoDefaultProps,
  companyImage: "/static/img/customers/discovery.png"
};
